module.exports = __webpack_public_path__ + "img/e226bf8.jpg";